import { Pipe, PipeTransform, inject } from '@angular/core';
import { Match } from '../_shared/models/match.model';
import { BoardHelpService } from '../match-tracker/tracker-board/board-help.service';
import { DisciplineEnum } from '../_shared/models/csTypes/enums/discipline';

@Pipe({
  name: 'ticker',
  pure: false,
  standalone: true
})
export class TickerPipe implements PipeTransform {
  transform(match: Match): string {
    if (match.score?.server?.sideNumber) {
      return  match.score.server.sideNumber === 1 ? match.score.scoreStringSide1 : match.score.scoreStringSide2;
    } else {
      return match.discipline === DisciplineEnum.PICKLEBALL || match.discipline === DisciplineEnum.BADMINTON
        ? 'Start game'
        : 'Start set';
    }

  }

}
